import { useEffect, useState } from "react";
import api from "@/lib/api";

const cache = new Map();

export default function Avatar({ user, size = "w-10 h-10", className = "" }) {
  const key = user?.photo_updated_at ? `${user.id}:${user.photo_updated_at}` : null;
  const [src, setSrc] = useState(key ? cache.get(key) : null);

  useEffect(() => {
    if (!key || cache.has(key)) {
      setSrc(key ? cache.get(key) : null);
      return;
    }
    let alive = true;
    api.get(`/users/${user.id}/photo`, { responseType: "blob" })
      .then((r) => { const u = URL.createObjectURL(r.data); cache.set(key, u); if (alive) setSrc(u); })
      .catch(() => {});
    return () => { alive = false; };
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps

  const initials = (user?.name || "?").split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
  return src ? (
    <img src={src} alt={user?.name} className={`${size} rounded-full object-cover ${className}`} data-testid={`avatar-${user?.id}`} />
  ) : (
    <div className={`${size} rounded-full bg-sky-100 text-sky-700 font-bold text-sm flex items-center justify-center ${className}`} data-testid={`avatar-${user?.id}`}>
      {initials}
    </div>
  );
}
